import { render, staticRenderFns } from "./parts-locations-general-card.vue?vue&type=template&id=ebfffc6e&scoped=true&"
import script from "./parts-locations-general-card.vue?vue&type=script&lang=js&"
export * from "./parts-locations-general-card.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-general-card.vue?vue&type=style&index=0&id=ebfffc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfffc6e",
  null
  
)

export default component.exports